<template>
    <div class="component-on-empty-page component-on-empty-page--center xpate-processing">
        <div class="text-center">
            <div class="chat-loader">
                <div class="spinner-border" role="status">
                    <span class="sr-only"></span>
                </div>
            </div>
            <p class="mt-3">{{ translate.transaction.processing }}</p>
        </div>
        <div class="xpate-processing__order-id">
            <small class="text-muted">{{ translate.transaction.order }} {{ orderId }}</small>
        </div>
    </div>
</template>

<script>
const MAX_POLL_ATTEMPTS = 15;
const POLL_INTERVAL_MS = 2000;

const props = {
    orderId: {
        type: String,
        required: true,
    },
    reloadUrl: {
        type: String,
        required: true,
    },
};

const data = () => {
    return {
        pollCount: 0,
        pollTimeoutId: null,
    };
};

function mounted() {
    this.poll();
}

function beforeDestroy() {
    if (this.pollTimeoutId) {
        clearTimeout(this.pollTimeoutId);
    }
}

async function poll() {
    this.pollCount++;

    const [err, result] = await to(api.transaction.guest.xpate.getOrderStatus(this.orderId));

    if (err) {
        this.scheduleNextPoll();
        return;
    }

    const status = _.get(result, 'data.results.status', 'pending');

    if (status === 'completed' || status === 'error') {
        window.location.replace(this.reloadUrl);
        return;
    }

    this.scheduleNextPoll();
}

function scheduleNextPoll() {
    if (this.pollCount >= MAX_POLL_ATTEMPTS) {
        window.location.replace(this.reloadUrl);
        return;
    }

    this.pollTimeoutId = setTimeout(() => this.poll(), POLL_INTERVAL_MS);
}

export default {
    props,
    data,
    mounted,
    beforeDestroy,
    methods: {
        poll,
        scheduleNextPoll,
    },
    computed: {
        ...mapState(['translate']),
    },
};
</script>
